import React from 'react'
import NavBar from "../Components/Navbar"
import Footer from '../Components/Footer'
import HeroImgForPages from '../Components/HeroImgForPages'
import Form from '../Components/Form'
function Contact() {
  return (
    <div>
      <NavBar />
      <HeroImgForPages heading="CONTACT" text="Shall We Work Together, Just Email Me" />
      <Form />
      <Footer />
    </div>
  )
}

export default Contact